<app-filter
    [filterConfig]="{
        searchPlaceholder: 'MESSAGING.SEARCH',
        hasDateRange: true,
        dateRangeStart: initStartDate,
        dateRangeEnd: initEndDate,
        checkboxGroups: [
            {
                id: 'meals',
                label: 'SHOP.WALLET.FILTERS.MEAL_TYPE',
                options: mealChoices,
                enable: currentEventType === eventTypesEnum.MEAL,
                checkAllChildrenByDefault: true
            },
            {
                id: 'education',
                label: 'SHOP.WALLET.FILTERS.EDUCATION_LEVEL',
                options: educationLevels,
                enable: currentEventType !== eventTypesEnum.HOMEWORK,
                checkAllChildrenByDefault: true
            },
            {
                id: 'homework',
                label: 'SHOP.WALLET.FILTERS.STUDY_TYPES',
                options: homeworkTypesSelectChoices,
                enable: currentEventType === eventTypesEnum.HOMEWORK,
                checkAllChildrenByDefault: true
            },
            {
                id: 'payment',
                label: 'SHOP.WALLET.FILTERS.PAYMENT_STATUS',
                options: paymentStatusChoices,
                enable: true,
                checkAllChildrenByDefault: true
            }
        ],
        actions: filterAction
    }"
    (applyFiltersEvent)="applyFiltersEvent($event)"
    *appCheckPermissions="permissions.shopping_history_search"
></app-filter>

<div *ngIf="bookedEvents && !isFiltersApplied" class="month-list">
    <ng-container *ngFor="let month of bookedEvents; let i = index">
        <div class="month card" *ngIf="monthComparison(month.monthNumber)">
            <div class="month-container">
                <div class="title row" (click)="showMonthDetails(month.monthNumber)">
                    <div class="col-11">
                        <div class="row">
                            <h4 class="col-md-6 col-6">{{ month.monthName | translate }} {{ getMonthYear(month.monthNumber) }}</h4>
                            <p class="meals-count col-md-6 col-6">
                                {{
                                    currentEducationLevel === 0
                                        ? month.eventsCount?.total
                                        : currentEducationLevel === 1
                                        ? month.eventsCount?.primary
                                        : month.eventsCount?.kindergarten
                                }}
                                {{
                                    currentEventType === eventTypesEnum.MEAL
                                        ? ('SHOP.MEAL.MEALS_HISTORY.MEALS_COUNTER' | translate)
                                        : ('SHOP.HOMEWORK.HISTORY.HOMEWORK_COUNTER' | translate)
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <span
                    (click)="showMonthDetails(month.monthNumber)"
                    class="icon i-angle-down"
                    [ngClass]="{ '-rotate': month.monthNumber === currentMonthDetails }"
                ></span>
            </div>
            <div class="history" *ngIf="currentMonthDetails === month.monthNumber">
                <!-- HISTORIQUE DES RéSERVATIONS DE REPAS -->
                <ng-container *ngIf="currentEventType === eventTypesEnum.MEAL">
                    <div *ngIf="month.eventsCount.total === 0">{{ 'SHOP.NO_RESULT' | translate }}</div>
                    <div class="row" *ngFor="let commande of month.bookedMeals">
                        <div class="col-md-2 col-6">{{ commande.meal.date | date: 'dd/MM' }}</div>
                        <div class="col-md-3 col-6" *ngIf="(currentUserType$ | async) !== entityTypeEnum.STUDENT">
                            {{ commande.student.firstname }} {{ commande.student.lastname }}
                        </div>
                        <div class="col-md-2 col-6" *ngIf="(currentUserType$ | async) === entityTypeEnum.EMPLOYEE">
                            {{ commande.student.school_class_name }}
                        </div>
                        <div class="col-6" [ngClass]="(currentUserType$ | async) === entityTypeEnum.EMPLOYEE ? 'col-md-2' : 'col-md-3'">
                            {{ 'ENUM.MEAL-CHOICES.' + commande.meal_choices[0].toUpperCase() | translate }}
                        </div>
                        <div class="col-6 col-md-1 price" *appCheckPermissions="permissions.wallet_view_price">
                            <p [ngClass]="{ green: commande.paymentStatus === paymentStatus.PAID }">
                                {{ commande.meal.amount || 0 | customPricing: true }}
                            </p>
                        </div>
                        <div class="col-1 line-actions-icons">
                            <!-- view parent  -->
                            <ng-container
                                *ngIf="(currentUserHasDivorcedParents$ | async) && (user$ | async)?.type === entityTypeEnum.EMPLOYEE"
                            >
                                <app-infobulle [icon]="'i-circle-user'">
                                    <p>{{ commande.parents[0].firstname }} {{ commande.parents[0].lastname }}</p>
                                </app-infobulle>
                            </ng-container>
                            <!-- delete order -->
                            <ng-container class="col-1" *appCheckPermissions="permissions.delete_order">
                                <span (click)="openPopupDeleteMealOrder(commande.id)" class="icon i-trash clickable"></span>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <!-- HISTORIQUE DES RESERVATIONS DES DEVOIRS -->
                <ng-container *ngIf="currentEventType === eventTypesEnum.HOMEWORK">
                    <div *ngIf="month.eventsCount?.total === 0">{{ 'SHOP.NO_RESULT' | translate }}</div>
                    <div class="row" *ngFor="let commande of month.bookedHomeworkSchool">
                        <div class="col-md-1 col-6">{{ commande.homeworkSchool.date | date: 'dd/MM' }}</div>
                        <div class="col-md-3 col-6" *ngIf="(currentUserType$ | async) !== entityTypeEnum.STUDENT">
                            {{ commande.student.firstname }} {{ commande.student.lastname }}
                        </div>
                        <div class="col-md-3 col-6">
                            {{
                                commande.homeworkSchool.homeworkType === homeworkTypes.HOMEWORK
                                    ? homeworkSchoolSettings.homework_name
                                    : homeworkSchoolSettings.reading_name
                            }}
                        </div>
                        <div class="col-md-3 col-6" *ngIf="(currentUserType$ | async) === entityTypeEnum.EMPLOYEE">
                            {{ commande.student.school_class_name }}
                        </div>
                        <div class="col-md-1 col-6 price" *appCheckPermissions="permissions.wallet_view_price">
                            <p [ngClass]="{ green: commande.paymentStatus === paymentStatus.PAID }">
                                {{ commande.homeworkSchool.amount || 0 | customPricing: true }}
                            </p>
                        </div>
                        <div class="col-md-1 col-1" *appCheckPermissions="permissions.delete_order">
                            <span (click)="openPopupDeleteHomeworkOrder(commande.id)" class="icon i-trash clickable"></span>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>

<div class="filtered-events" *ngIf="isFiltersApplied">
    <!-- HISTORIQUE FILTRé DES RéSERVATIONS DE REPAS -->
    <ng-container *ngIf="currentEventType === eventTypesEnum.MEAL && filteredBookedMeals$ | async as filteredEvents">
        <div class="row" *ngFor="let commande of filteredEvents">
            <div class="col-md-2 col-6">{{ commande.meal.date | date: 'dd/MM/yyyy' }}</div>
            <div class="col-md-3 col-6" *ngIf="(currentUserType$ | async) !== entityTypeEnum.STUDENT">
                {{ commande.student.firstname }} {{ commande.student.lastname }}
            </div>
            <div class="col-md-2 col-6" *ngIf="(currentUserType$ | async) === entityTypeEnum.EMPLOYEE">
                {{ commande.student.school_class_name }}
            </div>
            <div class="col-6" [ngClass]="(currentUserType$ | async) === entityTypeEnum.EMPLOYEE ? 'col-md-2' : 'col-md-3'">
                {{ 'ENUM.MEAL-CHOICES.' + commande.meal_choices[0].toUpperCase() | translate }}
            </div>
            <div class="col-6 col-md-2 price" *appCheckPermissions="permissions.wallet_view_price">
                <p [ngClass]="{ green: commande.paymentStatus === paymentStatus.PAID }">
                    {{ commande.meal.amount || 0 | customPricing: true }}
                </p>
            </div>
            <div class="col-md-1 col-1" *appCheckPermissions="permissions.delete_order">
                <span (click)="openPopupDeleteMealOrder(commande.id)" class="icon i-trash clickable"></span>
            </div>
        </div>
    </ng-container>
    <!-- HISTORIQUE FILTRé DES RESERVATIONS DES DEVOIRS -->
    <ng-container *ngIf="currentEventType === eventTypesEnum.HOMEWORK && filteredBookedHomeworkSchool$ | async as filteredEvents">
        <div class="row" *ngFor="let events of filteredEvents">
            <div class="col-md-2 col-6">{{ events.homeworkSchool.date | date: 'dd/MM/yyyy' }}</div>
            <div class="col-md-3 col-6" *ngIf="(currentUserType$ | async) !== entityTypeEnum.STUDENT">
                {{ events.student.firstname }} {{ events.student.lastname }}
            </div>
            <div class="col-md-3 col-6">
                {{
                    events.homeworkSchool.homeworkType === homeworkTypes.HOMEWORK
                        ? homeworkSchoolSettings.homework_name
                        : homeworkSchoolSettings.reading_name
                }}
            </div>
            <div class="col-md-2 col-6" *ngIf="(currentUserType$ | async) === entityTypeEnum.EMPLOYEE">
                {{ events.student.school_class_name }}
            </div>
            <div class="col-md-1 col-6 price" *appCheckPermissions="permissions.wallet_view_price">
                <p [ngClass]="{ green: events.paymentStatus === paymentStatus.PAID }">
                    {{ events.homeworkSchool.amount || 0 | customPricing: true }}
                </p>
            </div>
            <div class="col-md-1 col-1" *appCheckPermissions="permissions.delete_order">
                <span (click)="openPopupDeleteHomeworkOrder(events.id)" class="icon i-trash clickable"></span>
            </div>
        </div>
    </ng-container>
</div>
